export function formatCpfCnpj(value) {
  if (!value) return value;

  let cpfCnpj = value;
  if (cpfCnpj.length <= 14) {
    cpfCnpj = cpfCnpj.replace(/\D/g, "");
    //Coloca um ponto entre o terceiro e o quarto dígitos
    cpfCnpj = cpfCnpj.replace(/(\d{3})(\d)/, "$1.$2")

    //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    cpfCnpj = cpfCnpj.replace(/(\d{3})(\d)/, "$1.$2")

    //Coloca um hífen entre o terceiro e o quarto dígitos
    cpfCnpj = cpfCnpj.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  } else {
    cpfCnpj = cpfCnpj.replace(/\D/g, "");
    //Coloca ponto entre o segundo e o terceiro dígitos
    cpfCnpj = cpfCnpj.replace(/^(\d{2})(\d)/, "$1.$2")

    //Coloca ponto entre o quinto e o sexto dígitos
    cpfCnpj = cpfCnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")

    //Coloca uma barra entre o oitavo e o nono dígitos
    cpfCnpj = cpfCnpj.replace(/\.(\d{3})(\d)/, ".$1/$2")

    //Coloca um hífen depois do bloco de quatro dígitos
    cpfCnpj = cpfCnpj.replace(/(\d{4})(\d)/, "$1-$2")
  }

  return cpfCnpj;
};

export const buscaCep = value => {
  const cep = value;

  return fetch(`https://viacep.com.br/ws/${cep}/json/`, { mode: 'cors' })
    .then((res) => res.json())
    // .then((data) => data })
    .catch(err => console.log(err));
};

export function formatTelefone(value) {
  if (!value) return value;

  let telefone = value;

  telefone = telefone.replace(/\D/g, "");

  //Coloca parênteses em volta dos dois primeiros dígitos
  telefone = telefone.replace(/^(\d{2})(\d)/g, "($1) $2");

  //Coloca hífen entre o quarto e o quinto dígitos
  telefone = telefone.replace(/(\d)(\d{4})$/, "$1-$2");

  return telefone;
};


// WEBPACK FOOTER //
// ./src/utils/functions.js